<template>
    <div class="category">
        <i class="head" @click="goto"></i>
        <div class="box">
            <div class="item">
                <div class="icon a" @click="goto"></div>
                <p class="name">新鑫系列</p>
                <p class="intro">混合型量化产品</p>
                <p class="detail">严格控制风险的基础上通过多策略资产配置的方式，追求最大化的绝对收益</p>
            </div>
            <div class="item">
                <div class="icon b" @click="goto"></div>
                <p class="name">博晟系列</p>
                <p class="intro">指数增强产品</p>
                <p class="detail">在控制短期波动的同时获取优质企业股权的内生价值增长</p>
            </div>
            <div class="item">
                <div class="icon c" @click="goto"></div>
                <p class="name">博智系列</p>
                <p class="intro">量化对冲产品</p>
                <p class="detail">在规避股票系统性风险的同时，获取优质股票组合的alpha绝对收益</p>
            </div>
            <div class="item">
                <div class="icon d" @click="goto"></div>
                <p class="name">正合系列</p>
                <p class="intro">固收产品</p>
                <p class="detail">在低风险和安全性的前提下投资固收类资产，追求合理的绝对收益</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        goto() {
            this.$router.push({
                name: 'investment',
                params: {
                    tab: 1
                }
            })
        }
    },
}
</script>